export default {
	apiRoot: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? '//130.208.108.18:8000/api/' : '/django/api/'
}
